"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditAndRemove_1 = require("./EditAndRemove");
exports.default = EditAndRemove_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/EditAndRemove/index.js
// module id = 286
// module chunks = 8